import { get, } from "@/api/axios";

// 列表
export const businessList = params => get('/web/region/business/list', params);

// 统计
export const businessCount = params => get('/web/region/business/count', params);